<template>
  <TabBar activeTabName="misc" />
  <div class="row justify-content-center px-0 mx-0">
    <NetworkServerInfo />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import NetworkServerInfo from '@/components/fleet/NetworkServerInfo.vue'
import TabBar from '@/components/fleet/TabBar.vue'

@Options({
  components: {
    NetworkServerInfo,
    TabBar
  }
})
export default class NetworkServerDetails extends Vue {}
</script>
